import { LocationFragment, LocationGroupFragment } from '@occc/graphql';
import { z } from 'zod';

export const homeStoreSchema = z
  .object({
    locations: z.array(z.custom<LocationFragment>()).optional(),
    locationGroups: z.array(z.custom<LocationGroupFragment>()).optional(),
  })
  .optional();
